import type { RouteObject } from "react-router-dom";

export const routes = {
  CONTEXT_EXPLORER: "/context-explorer",
  VFS_GRANTS: "/settings/vfs-folders",
  VFS_PROVIDERS: "/settings/vfs-providers",
} as const;

/** Registered in app/router/routesConfig.tsx (same pattern as meetingRoutes). */
export const contextExplorerRoutes: RouteObject[] = [
  {
    path: "context-explorer",
    lazy: () =>
      import("@/features/context-explorer/pages/ContextExplorerPage").then(
        (m) => ({
          Component: m.ContextExplorerPage,
        })
      ),
  },
  {
    path: "context",
    lazy: () =>
      import("@/features/context-explorer/pages/ContextExplorerPage").then(
        (m) => ({
          Component: m.ContextExplorerPage,
        })
      ),
  },
  {
    path: "settings/vfs-folders",
    lazy: () =>
      import("@/features/context-explorer/pages/VfsGrantsPage").then((m) => ({
        Component: m.VfsGrantsPage,
      })),
  },
  {
    path: "context/vfs",
    lazy: () =>
      import("@/features/context-explorer/pages/VfsGrantsPage").then((m) => ({
        Component: m.VfsGrantsPage,
      })),
  },
  {
    path: "settings/vfs",
    lazy: () =>
      import("@/features/context-explorer/pages/VfsGrantsPage").then((m) => ({
        Component: m.VfsGrantsPage,
      })),
  },
  {
    // Admin-only: the page itself renders "no access" for non-admins.
    path: "settings/vfs-providers",
    lazy: () =>
      import("@/features/context-explorer/pages/VfsProvidersPage").then(
        (m) => ({
          Component: m.VfsProvidersPage,
        })
      ),
  },
  {
    path: "context/vfs/providers",
    lazy: () =>
      import("@/features/context-explorer/pages/VfsProvidersPage").then(
        (m) => ({
          Component: m.VfsProvidersPage,
        })
      ),
  },
];
